import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SeoService } from '../../shared/services/seo-service/seo.service';
@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.css',
})
export class AboutUsComponent {
  sidebarVisible: boolean = false;

  constructor(
    private router: Router,
    private seo: SeoService,
  ) {}

  ngOnInit() {
    this.seo.update({
      title: 'About Coinwush | Institutional-Grade Crypto Derivatives Exchange',
      description:
        'Learn about Coinwush — a next-generation crypto derivatives exchange built for professional traders with low latency execution, advanced margining, and secure INR settlements.',
      keywords:
        'About Coinwush, crypto exchange company, professional crypto trading platform, crypto derivatives India',
      url: 'https://coinwush.com/about',
    });
  }

  navigate(route: string): void {
    this.router.navigate([route]);
  }
}
